export const spacing = {
  unit: 8,
  none: 0,
  xxs: 2,
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
  '2xl': 24,
  '3xl': 32,
  '4xl': 40,
  '5xl': 48,
  '6xl': 64,
  pagePadding: {
    mobile: 16,
    tablet: 24,
    desktop: 32,
  },
  cardPadding: {
    small: 12,
    medium: 16,
    large: 24,
  },
  sectionSpacing: {
    small: 24,
    medium: 32,
    large: 48,
  },
} as const;

export const sp = (multiplier: number): number => spacing.unit * multiplier;

export const gaps = {
  row: {
    sm: 8,
    md: 16,
    lg: 24,
  },
  column: {
    sm: 8,
    md: 16,
    lg: 24,
  },
} as const;
